import React, { useContext, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import { CheckboxTable } from "../../view/CheckboxTable";
import { useRemediationTableHelper } from "./useRemediationTableHelper";
import RemediationTableRow from "./RemediationTableRow";
import RemediationTableRowSkeleton from "./RemediationTableRowSkeleton";
import { TableContext } from "../../index";
import ValidateHeaderMenuItem from "../validate/ValidateHeaderMenuItem";
// import * as remediationService from "./remediationService";

function RemediationTable({ remediations = [] }) {

    const helper = useRemediationTableHelper();
    const { config } = useContext(TableContext);

    const dataColumns = [
        { name: 'RULE NAME', state: true, sortKey: 'rule', onClick: () => helper.onRuleClick() },
        { name: 'DEVICE', state: true, sortKey: 'device', onClick: () => helper.onDeviceClick() },
        { name: 'SECTION', state: false, sortKey: 'sectionName', onClick: () => helper.onSectionClick() },
        { name: 'SUBSECTION', state: false, sortKey: 'subsectionName', onClick: () => helper.onSubsectionClick() },
        { name: 'SEVERITY', state: true, sortKey: 'severity', onClick: () => helper.onSeverityClick() },
        { name: 'PREVIOUS VALID', state: true, sortKey: 'previousValid', onClick: () => helper.onPreviousValidClick() },
        { name: 'CURRENT VALID', state: true, sortKey: 'valid', onClick: () => helper.onValidClick() },
        { name: 'USER', state: true, sortKey: 'user', onClick: () => helper.onUserClick() },
        { name: 'DATE', state: true, sortKey: 'remediateStartTime', onClick: () => helper.onDateClick() },
    ]

    const [hiddenHeaders, setHiddenHeaders] = useState(
        dataColumns.filter(column => column.state !== true).map(column => column.name)
    );
    const [updatedColumns, setUpdatedColumns] = useState(dataColumns);

    const columnMenu = [{
        name: <ValidateHeaderMenuItem
            updatedHiddenHeaders={hiddenHeaders}
            sendHiddenHeaders={(nextHiddenHeaders) => setHiddenHeaders([...nextHiddenHeaders])}
            dataColumns={updatedColumns}
            sendUpdatedDataColumns={(nextColumns) => setUpdatedColumns(nextColumns)}
        />,
        className: "oct_table-actions-cell-v2"
    }];

    const headers = [
        ...updatedColumns.filter(column => column.state === true),
        ...columnMenu
    ];

    // Client-side search filtering
    const searchTerm = (config.searchTerm || '').toLowerCase();
    const filteredList = searchTerm
        ? remediations.filter(item => {
            const rule = (item.rule || '').toLowerCase();
            const device = (item.device || '').toLowerCase();
            const sectionName = (item.sectionName || '').toLowerCase();
            const subsectionName = (item.subsectionName || '').toLowerCase();
            const user = (item.user || '').toLowerCase();
            const severity = (item.severity || '').toLowerCase();
            return rule.includes(searchTerm) || device.includes(searchTerm) ||
                sectionName.includes(searchTerm) || subsectionName.includes(searchTerm) ||
                user.includes(searchTerm) || severity.includes(searchTerm);
        })
        : remediations;

    return (
        <>
            <CheckboxTable headers={headers} elements={filteredList} containsEditButton={false}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <RemediationTableRowSkeleton key={index} index={index} hiddenHeaders={hiddenHeaders} />
                    ))
                ) : (
                    filteredList.map((data, index) => <RemediationTableRow configPath={helper.configPath} key={index} data={data}
                        index={index} hiddenHeaders={hiddenHeaders} />)
                )}
            </CheckboxTable>
            {!config.isLoading && filteredList.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );

}


function mapStateToProps(state) {
    debug("parametersTable mapStateToProps", state);
    const remediationPage = state.remediationPage;
    return {
        remediations: remediationPage.remediations || []
    };
}

export default connect(mapStateToProps)(RemediationTable)
